import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon";
import { Text } from "../Text";

const Row = styled("div")`
  display: flex;
  align-items: center;
  height: 28px;
  gap: 4px;
  padding: 6px 10px 6px 8px;
  width: fit-content;
`;

export function ActivityLine({
  icon,
  iconColor,
  children,
}: {
  icon: IconName;
  iconColor?: string;
  children: ReactNode;
}) {
  return (
    <Row>
      <Icon
        name={icon}
        size={12}
        color={iconColor ?? "var(--text-secondary)"}
      />
      <Text variant="text-small" color="var(--text-secondary)">
        {children}
      </Text>
    </Row>
  );
}
